<template>
  <div class="profile-page">
    <!-- Hero -->
    <section class="profile-hero" style="background-image: var(--tkd-gradient-hero), url(/images/banner.jpg)">
      <div class="hero-inner">
        <div class="avatar-wrap">
          <div class="avatar">
            <img v-if="imgDataUrl && !avatarFailed" :src="imgDataUrl" alt="Фото профілю" @error="avatarFailed = true">
            <span v-else class="avatar-initials">{{ initials }}</span>
          </div>
          <button type="button" class="avatar-edit" @click="toggleShow" title="Змінити фото" aria-label="Змінити фото"><tkd-icon name="camera"/></button>
        </div>

        <div class="hero-text" v-if="user">
          <div class="hero-badge"><span class="badge-dot"></span>Секретар</div>
          <h1 class="hero-name">{{ fullName }}</h1>
          <div class="hero-meta">
            <span v-if="user.username">@{{ user.username }}</span>
            <span v-if="user.email">{{ user.email }}</span>
          </div>
        </div>
        <div class="hero-text" v-else>
          <div class="skeleton skeleton-badge"></div>
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-line"></div>
        </div>
      </div>
    </section>

    <div class="profile-grid">
      <!-- Personal data -->
      <section class="panel">
        <div class="panel-head">
          <h2>Особисті дані</h2>
          <span class="panel-hint"><tkd-icon name="lock"/> Тільки перегляд</span>
        </div>

        <div class="info-grid" v-if="user">
          <div class="info-item" v-for="field in fields" :key="field.key">
            <div class="info-label">{{ field.label }}</div>
            <div class="info-value">
              <span>{{ user[field.key] || '—' }}</span>
              <button
                v-if="user[field.key]"
                type="button"
                class="copy-btn"
                @click="copy(field.key)"
                :title="copied === field.key ? 'Скопійовано' : 'Скопіювати'"
              ><tkd-icon :name="copied === field.key ? 'check' : 'copy'"/></button>
            </div>
          </div>
        </div>
        <div class="info-grid" v-else>
          <div class="info-item" v-for="n in 4" :key="n">
            <div class="skeleton skeleton-label"></div>
            <div class="skeleton skeleton-value"></div>
          </div>
        </div>

        <div class="panel-note">
          Щоб змінити особисті дані, зверніться до <b>Федерації Тхеквондо України</b>.
        </div>
      </section>

      <!-- Side -->
      <aside class="side">
        <section class="panel">
          <div class="panel-head"><h2>Швидкі дії</h2></div>
          <router-link to="/user/tournaments" class="action action-primary">
            <span class="action-icon"><tkd-icon name="trophy"/></span>
            <span class="action-text">
              <b>Турніри</b>
              <small>Перегляд і керування турнірами</small>
            </span>
            <span class="action-arrow"><tkd-icon name="arrow-right"/></span>
          </router-link>
          <button type="button" class="action" @click="toggleShow">
            <span class="action-icon"><tkd-icon name="image"/></span>
            <span class="action-text">
              <b>Змінити фото</b>
              <small>PNG, обрізка 300×300</small>
            </span>
            <span class="action-arrow"><tkd-icon name="arrow-right"/></span>
          </button>
          <button type="button" class="action action-danger" @click="logout">
            <span class="action-icon"><tkd-icon name="logout"/></span>
            <span class="action-text">
              <b>Вийти</b>
              <small>Завершити сесію на цьому пристрої</small>
            </span>
          </button>
        </section>
      </aside>
    </div>

    <my-upload field="img"
               @crop-success="cropSuccess"
               @crop-upload-success="cropUploadSuccess"
               @crop-upload-fail="cropUploadFail"
               v-model="show"
               :noRotate="false"
               :width="300"
               :height="300"
               :url="baseUrlServer + '/user/upload-avatar'"
               :params="params"
               :headers="headers"
               lang-type="ua"
               img-format="png"></my-upload>
  </div>
</template>
<script>
  import 'src/assets/css/tkd-theme.css';
  import myUpload from 'vue-image-crop-upload';

  import {baseUrlServer} from '../../api/user';

  export default {
    components: {
      'my-upload': myUpload
    },
    data () {
      return {
        baseUrlServer: '',
        fields: [
          { key: 'fname', label: "Ім'я" },
          { key: 'lname', label: 'Прізвище' },
          { key: 'email', label: 'Email' },
          { key: 'username', label: 'Логін' },
        ],
        copied: '',
        avatarFailed: false,
        show: false,
        params: {
          token: '123456798',
          name: 'avatar'
        },
        headers: {
          smail: '*_~'
        },
        imgDataUrl: '' // the datebase64 url of created image
      }
    },

    computed: {
      userOne() {
        return this.$store.getters['user/userOne'];
      },
      user() {
        return this.userOne && this.userOne.data ? this.userOne.data.user : null;
      },
      fullName() {
        let name = [this.user.fname, this.user.lname].filter(Boolean).join(' ');
        return name || this.user.username || 'Секретар';
      },
      initials() {
        if (!this.user) return '';
        let source = [this.user.fname, this.user.lname].filter(Boolean);
        if (!source.length && this.user.username) source = [this.user.username];
        return source.map(part => part.charAt(0).toUpperCase()).join('').slice(0, 2);
      }
    },
    created(){
      this.baseUrlServer = baseUrlServer;
      this.setAvatar();

      const token = localStorage.getItem('jwt')
      if (token) {
        this.headers = {'Authorization':'Bearer '+token, 'WWW-Authenticate':'Bearer '+token};
      }
    },
    watch: {
      userOne: function() {
        this.setAvatar();
      }
    },

    methods: {
      setAvatar() {
        if (this.user) {
          this.avatarFailed = false;
          this.imgDataUrl = this.user.img
            ? this.baseUrlServer + this.user.img
            : this.baseUrlServer + '/images/user-default.png';
        }
      },
      copy(key) {
        let value = this.user[key];
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(value).then(() => {
          this.copied = key;
          setTimeout(() => { if (this.copied === key) this.copied = ''; }, 1500);
        });
      },
      logout() {
        localStorage.removeItem('jwt');
        this.$router.replace({ path: `/login` });
      },
      toggleShow() {
        this.show = !this.show;
      },
      cropSuccess(imgDataUrl, field){
        this.avatarFailed = false;
        this.imgDataUrl = imgDataUrl;
      },
      cropUploadSuccess(jsonData, field){
        this.$notify && this.$notify({ type: 'success', text: 'Фото оновлено' });
      },
      cropUploadFail(status, field){
        console.log('avatar upload fail', status);
        this.setAvatar();
      }
    }
  }

</script>
<style scoped>
  .profile-page {
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
    padding: 30px 15px 40px;
    font-family: var(--tkd-font);
    color: var(--tkd-text);
    animation: rise 0.5s ease-out both;
  }

  /* Hero */
  .profile-hero {
    position: relative;
    overflow: hidden;
    padding: 36px 36px 32px;
    border-radius: var(--tkd-radius-lg);
    background-color: var(--tkd-navy);
    background-position: center;
    background-size: cover;
    box-shadow: 0 20px 50px rgba(10, 31, 68, 0.25);
    color: #fff;
  }

  .hero-inner {
    display: flex;
    align-items: center;
    gap: 28px;
  }

  .avatar-wrap { position: relative; flex-shrink: 0; }

  .avatar {
    width: 112px;
    height: 112px;
    border-radius: 28px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--tkd-gradient-btn);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35), 0 0 0 4px rgba(255, 255, 255, 0.15);
  }

  .avatar img { width: 100%; height: 100%; object-fit: cover; }

  .avatar-initials {
    font-size: 40px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 0.02em;
  }

  .avatar-edit {
    position: absolute;
    right: -8px;
    bottom: -8px;
    width: 38px;
    height: 38px;
    border: 3px solid var(--tkd-navy);
    border-radius: 50%;
    background: var(--tkd-yellow);
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    transition: transform 0.15s;
  }

  .avatar-edit:hover { transform: scale(1.08); }
  .avatar-edit:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

  .hero-text { min-width: 0; flex: 1; }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--tkd-yellow);
    background: rgba(255, 213, 0, 0.1);
    border: 1px solid rgba(255, 213, 0, 0.35);
  }

  .badge-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--tkd-yellow);
    animation: pulse 2s infinite;
  }

  .hero-name {
    margin: 12px 0 8px;
    font-size: 36px;
    line-height: 1.1;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.02em;
    overflow-wrap: anywhere;
  }

  .hero-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 18px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.72);
    overflow-wrap: anywhere;
  }

  /* Layout */
  .profile-grid {
    display: grid;
    grid-template-columns: 1.6fr 1fr;
    gap: 24px;
    margin-top: 24px;
    align-items: start;
  }

  .panel {
    background: var(--tkd-surface);
    border: 1px solid var(--tkd-border);
    border-radius: var(--tkd-radius-lg);
    padding: 26px 26px 22px;
    box-shadow: var(--tkd-shadow);
  }

  .panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 18px;
  }

  .panel-head h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--tkd-text);
  }

  .panel-hint {
    font-size: 12px;
    font-weight: 600;
    color: var(--tkd-muted);
    white-space: nowrap;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }

  .info-item {
    padding: 12px 14px;
    border-radius: var(--tkd-radius);
    background: var(--tkd-bg);
    border: 1.5px solid var(--tkd-border);
    min-width: 0;
  }

  .info-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--tkd-blue);
    margin-bottom: 4px;
  }

  .info-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 16px;
    min-height: 26px;
  }

  .info-value span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .copy-btn {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: var(--tkd-muted);
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s, background 0.15s;
  }

  .info-item:hover .copy-btn,
  .copy-btn:focus-visible { opacity: 1; }
  .copy-btn:hover { background: rgba(0, 87, 183, 0.08); color: var(--tkd-blue); }

  .panel-note {
    margin-top: 18px;
    padding: 12px 14px;
    border-radius: var(--tkd-radius);
    font-size: 14px;
    line-height: 1.5;
    color: var(--tkd-muted);
    background: rgba(0, 87, 183, 0.05);
    border: 1px dashed rgba(0, 87, 183, 0.25);
  }

  /* Actions */
  .action {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 14px;
    margin-bottom: 10px;
    border: 1.5px solid var(--tkd-border);
    border-radius: var(--tkd-radius);
    background: var(--tkd-surface);
    color: var(--tkd-text);
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
  }

  .action:last-child { margin-bottom: 0; }

  .action:hover {
    color: var(--tkd-text);
    text-decoration: none;
    border-color: var(--tkd-blue);
    box-shadow: 0 0 0 4px rgba(0, 87, 183, 0.08);
    transform: translateY(-1px);
  }

  .action:focus-visible { outline: 2px solid var(--tkd-blue); outline-offset: 2px; }

  .action-icon {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 20px;
    background: var(--tkd-bg);
  }

  .action-text { flex: 1; display: flex; flex-direction: column; min-width: 0; }
  .action-text b { font-size: 15px; }
  .action-text small { font-size: 13px; color: var(--tkd-muted); }
  .action-arrow { color: var(--tkd-muted); font-size: 18px; transition: transform 0.15s; }
  .action:hover .action-arrow { transform: translateX(3px); color: var(--tkd-blue); }

  .action-primary {
    color: #fff;
    border-color: transparent;
    background: var(--tkd-gradient-btn);
    box-shadow: 0 10px 24px rgba(0, 87, 183, 0.3);
  }
  .action-primary .action-icon { background: rgba(255, 255, 255, 0.16); }
  .action-primary .action-text small,
  .action-primary .action-arrow { color: rgba(255, 255, 255, 0.8); }
  .action-primary:hover { color: #fff; border-color: transparent; box-shadow: 0 14px 30px rgba(0, 87, 183, 0.4); }
  .action-primary:hover .action-arrow { color: #fff; }

  .action-danger:hover { border-color: #f04438; box-shadow: 0 0 0 4px rgba(240, 68, 56, 0.08); }
  .action-danger b { color: #b42318; }
  .action-danger .action-icon { background: #fef3f2; }

  /* Skeleton */
  .skeleton {
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.12) 50%, rgba(0, 0, 0, 0.06) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
  }
  .profile-hero .skeleton {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.22) 50%, rgba(255, 255, 255, 0.1) 75%);
    background-size: 200% 100%;
  }
  .skeleton-badge { width: 110px; height: 24px; border-radius: 999px; }
  .skeleton-title { width: 60%; height: 36px; margin: 14px 0 10px; }
  .skeleton-line { width: 40%; height: 16px; }
  .skeleton-label { width: 40%; height: 12px; margin-bottom: 8px; }
  .skeleton-value { width: 75%; height: 18px; }

  @keyframes rise { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
  @keyframes shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(255, 213, 0, 0.6); }
    70% { box-shadow: 0 0 0 8px rgba(255, 213, 0, 0); }
    100% { box-shadow: 0 0 0 0 rgba(255, 213, 0, 0); }
  }

  @media (max-width: 900px) {
    .profile-grid { grid-template-columns: 1fr; }
  }

  @media (max-width: 600px) {
    .profile-hero { padding: 28px 20px 26px; }
    .hero-inner { flex-direction: column; text-align: center; gap: 20px; }
    .hero-meta { justify-content: center; }
    .hero-name { font-size: 28px; }
    .avatar { width: 96px; height: 96px; border-radius: 24px; }
    .info-grid { grid-template-columns: 1fr; }
    .panel { padding: 20px 16px 18px; }
    .copy-btn { opacity: 1; }
  }

  @media (prefers-reduced-motion: reduce) {
    .profile-page, .badge-dot, .skeleton { animation: none; }
  }
</style>
